export default function sortTags(tags) {
  if (tags === void 0) {
    tags = [];
  }
  return tags.slice().sort((a, b) => (a?.name() || '').localeCompare(b?.name() || ''));
}
flarum.reg.add('nightash-labels', 'common/utils/sortTags', sortTags);